interface ProductOffers {
  [locale: string]: string;
}

interface FinancingProduct {
  title: ProductOffers;
  subtitle: ProductOffers;
  summaryTitle: ProductOffers;
  description: ProductOffers;
}

interface MapperFinancingProduct {
  [key: string]: FinancingProduct;
}

export const mapperFinanceProducts: MapperFinancingProduct = {
  standardFinancing: {
    title: {
      uk: 'Car Credit',
      fr: 'Crédit Auto',
      de: 'Standardfinanzierung',
    },
    subtitle: {
      uk: 'Direct Purchase',
      fr: 'Achat direct',
      de: 'Direktkauf',
    },
    summaryTitle: {
      uk: 'Car Credit',
      fr: 'Crédit Auto',
      de: 'Ein Finanzierungsbeispiel der Volkswagen Bank GmbH',
    },
    description: {
      uk: 'You finance your car with or without a down paymukt...',
      fr: 'Grâce au crédit automobile, vous financez...',
      de: 'Mit einem Autokredit finanzieruk Sie Ihr Auto...',
    },
  },
  privateLeasing: {
    title: {
      uk: 'Private Leasing',
      fr: 'LOA',
      de: 'PrivatLeasing',
    },
    subtitle: {
      uk: 'Leasing with Purchase Option',
      fr: 'location avec Option d’Achat',
      de: 'Leasing mit Kaufoption',
    },
    summaryTitle: {
      uk: 'Private Leasing Services',
      fr: 'LOA Mobilize Financial Services',
      de: 'Ein Finanzierungsbeispiel der Volkswagen Bank GmbH',
    },
    description: {
      uk: 'The Lease with Purchase Option...',
      fr: "La Location avec Option d'Achat...",
      de: 'Das Leasing mit Kaufoption ist eine Mietlösung...',
    },
  },
  vwfsPrivateLeasing: {
    title: {
      uk: 'Long-Term Leasing',
      fr: 'Location Longue Durée',
      de: 'Langfristiges Leasing',
    },
    subtitle: {
      uk: 'Leasing without Purchase Option',
      fr: 'location sans Option d’Achat',
      de: 'Leasing ohne Kaufoption',
    },
    summaryTitle: {
      uk: 'Long-Term Leasing',
      fr: 'Location Longue Durée',
      de: 'Langfristiges Leasing',
    },
    description: {
      uk: 'A flexible solution to rent without ownership',
      fr: "La Location avec Option d'Achat est une solution de location. Vous êtes locataire et payez mensuellement des loyers choisis lors de la signature de votre contrat en fonction de vos besoins. A la fin du contrat, vous avez la possibilité de devenir propriétaire de la voiture ou de la rendre sans vous soucier de la reprise.",
      de: 'Eine flexible Lösung, um ohne Eigentum zu mieten...',
    },
  },
  twoWayFinancing: {
    title: {
      uk: 'Short-Term Leasing',
      fr: 'Location Longue Durée',
      de: 'Finanzierung mit Schlussrate',
    },
    subtitle: {
      uk: 'Leasing without Purchase Option',
      fr: 'location sans Option d’Achat',
      de: 'Leasing ohne Kaufoption',
    },
    summaryTitle: {
      uk: 'Long-Term Leasing',
      fr: 'Location Longue Durée',
      de: 'Ein Finanzierungsbeispiel der Porsche Financial Services',
    },
    description: {
      uk: 'A flexible solution to rent without ownership...',
      fr: 'Une solution flexible pour louer sans être propriétaire...',
      de: 'Eine flexible Lösung, um ohne Eigentum zu mieten...',
    },
  },
  threeWayFinancing: {
    title: {
      uk: 'Long-Term Leasing',
      fr: 'Location Longue Durée',
      de: '3-Wege-Finanzierung',
    },
    subtitle: {
      uk: 'Leasing without Purchase Option',
      fr: 'location sans Option d’Achat',
      de: 'Leasing ohne Kaufoption',
    },
    summaryTitle: {
      uk: 'Long-Term Leasing',
      fr: 'Location Longue Durée',
      de: 'Ein Finanzierungsbeispiel der Volkswagen Bank GmbH',
    },
    description: {
      uk: 'A flexible solution to rent without ownership...',
      fr: 'Une solution flexible pour louer sans être propriétaire...',
      de: 'Eine flexible Lösung, um ohne Eigentum zu mieten...',
    },
  },
  HP: {
    title: {
      uk: 'HP',
      fr: 'Achat à crédit (HP)',
      de: 'Ratenkauf (HP)',
    },
    subtitle: {
      uk: 'Hire Purchase',
      fr: 'Achetez une voiture sur une période déterminée',
      de: 'Kaufen Sie ein Auto über einen festen Zeitraum',
    },
    summaryTitle: {
      uk: 'HP (Hire Purchase)',
      fr: 'Achat à crédit',
      de: 'Ratenkauf',
    },
    description: {
      uk: 'Buy a car outright over a fixed period',
      fr: 'Vous possédez la voiture après avoir payé toutes les mensualités...',
      de: 'Nach Abschluss aller Zahlungen besitzen Sie das Auto...',
    },
  },
  PCP: {
    title: {
      uk: 'PCP',
      fr: 'Plan de Contrat Personnel (PCP)',
      de: 'Persönlicher Vertragsplan (PCP)',
    },
    subtitle: {
      uk: 'Personal Contract Plan',
      fr: 'Payez mensuellement, puis achetez, échangez ou retournez',
      de: 'Monatlich zahlen, dann kaufen, tauschen oder zurückgeben',
    },
    summaryTitle: {
      uk: 'PCP (Personal Contract Plan)',
      fr: 'Financement PCP',
      de: 'PCP Finanzierung',
    },
    description: {
      uk: 'Pay monthly then buy, swap or return',
      fr: 'Des paiements mensuels réduits avec des options flexibles à la fin...',
      de: 'Niedrigere monatliche Zahlungen mit flexiblen Optionen am Ende...',
    },
  },
};

interface MapperFinancingProductOption {
  [key: string]: { label: string };
}

export const mapperFinanceProductOptions: MapperFinancingProductOption = {
  duration: {
    label: 'Term',
  },
  mileage: {
    label: 'Annual mileage',
  },
};

export const CAPTIVE_MAP = {
  RCI: 'rb_fr',
  VWFS: 'vwfs_fr',
  CGI: 'cgi_fr',
  VWFSDE: 'vwfs',
  AEB: 'aeb',
  PFS: 'pfs',
  RCIDE: 'rb',
  NB: 'nb',
};

export const isVwfs = (captive: string) => {
  return !!(captive === CAPTIVE_MAP.VWFS);
};

export const isRci = (captive: string) => {
  return !!(captive === CAPTIVE_MAP.RCI);
};
export const isCgi = (captive: string) => {
  return !!(captive === CAPTIVE_MAP.CGI);
};
export const isVwfsDe = (captive: string) => {
  return !!(captive === CAPTIVE_MAP.VWFSDE);
};

export const isAeb = (captive: string) => {
  return !!(captive === CAPTIVE_MAP.AEB);
};

export const isPfs = (captive: string) => {
  return !!(captive === CAPTIVE_MAP.PFS);
};

export const isRciDe = (captive: string) => {
  return !!(captive === CAPTIVE_MAP.RCIDE);
};

export const isNb = (captive: string) => {
  return !!(captive === CAPTIVE_MAP.NB);
};
